import React, { Component } from "react";
import { ToastContainer, toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTrash,
  faEye,
  faUniversity,
  faPen,
  faArrowLeft,
  faLink,
  faCopy,
  faUpload,
  faFile,
  faPlus,
  faArrowRight,
  faSave,
  faSearch,
  faFileText,
  faEdit,
} from "@fortawesome/free-solid-svg-icons";
import Cookies from "js-cookie";

import InputMask from "react-input-mask";
import vazio from "../../../img/vazio.svg";
import { StaticDialog } from "react-st-modal";
import {
  Box,
  Button,
  MenuItem,
  Modal,
  TextField,
  Typography,
} from "@mui/material";
import { Link, json } from "react-router-dom";
import { apiUrl } from "../../../comp/ApiUrl";

class Atributos extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPage: 0,
      itemsPerPage: 50,
      new: false,
      data: [],
      trash: {},
      dados: { valor: 0 },
      edit: {},
      imagem: null,
      Loader: true,
      searchTerm: "",
      searchResults: [],
      showSearchResults: false,
    };
  }

  componentDidMount() {
    document.title = "Atributos | FazPedido";
    fetch(`${apiUrl}/produtos/atributos`, {
      method: "GET",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + Cookies.get("auth_token"),
      },
    }).then((response) => {
      if (response.status == 200) {
        response.json().then((data) => {
          this.setState({ data, Loader: false });
        });
      }
    });
  }

  handleChange = (event) => {
    const { name, value } = event.target;
    this.setState((prevState) => ({
      dados: {
        ...prevState.dados,
        [name]: value,
      },
    }));
  };

  formatarDataBR(isoDate) {
    return new Date(isoDate).toLocaleString("pt-BR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    });
  }
  handlePageChange = (page) => {
    this.setState({ currentPage: page });
  };

  handleSearch = (event) => {
    const searchTerm = event.target.value.toLowerCase();

    this.setState({ searchTerm }, () => {
      if (searchTerm.length > 0) {
        const searchResults = this.state.data.filter((item) =>
          Object.values(item).some(
            (value) =>
              typeof value === "string" &&
              value.toLowerCase().includes(searchTerm)
          )
        );

        this.setState({
          searchResults,
          showSearchResults: true,
          currentPage: 0,
        });
      } else {
        this.setState({
          searchResults: [],
          showSearchResults: false,
          currentPage: 0,
        });
      }
    });
  };

  _ClickEdit(item) {
    return (
      <>
        <Link
          className="btn btn-primary d-flex align-items-center"
          to={`/${window.location.pathname.split("/")[1]}/editar/cartorio/${
            item.id
          }`}
        >
          <FontAwesomeIcon icon={faEdit} /> Editar
        </Link>
      </>
    );
  }

  render() {
    const {
      currentPage,
      itemsPerPage,
      searchTerm,
      searchResults,
      showSearchResults,
    } = this.state;
    const data = showSearchResults ? searchResults : this.state.data || []; // Agora data vem das props

    const totalPages = Math.ceil(data.length / itemsPerPage);
    const startIndex = currentPage * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    const dataPaginada = data.slice(startIndex, endIndex);
    if (this.state.Loader == true) {
      return (
        <>
          <div className="loader-container">
            <div class="loader"></div>
          </div>
        </>
      );
    }
    return (
      <main>
        <header class="bg-white ">
          <div class="max-w-7xl mx-auto py-6 px-4 sm:px-6 lg:px-8">
            <button onClick={() => this.props.navigate(-1)}>
              <FontAwesomeIcon icon={faArrowLeft} /> <strong>Atributos</strong>
            </button>
          </div>
        </header>
        <div className="py-12">
          <div className="max-w-7xl mx-auto sm:px-6 lg:px-8">
            <div className="col-12">
              <div className="card bg-white">
                <div className="card-header d-flex justify-content-between">
                  <div className="input-group w-50">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Pesquisar:"
                      value={searchTerm}
                      onChange={this.handleSearch}
                    />
                    <button className="btn btn-primary">
                      <FontAwesomeIcon icon={faSearch} />
                    </button>
                  </div>
                  <div className="d-flex gap-2">
                    <button
                      to="/produtos/novo"
                      className="btn btn-primary"
                      onClick={() => this.setState({ new: true })}
                    >
                      <FontAwesomeIcon icon={faPlus} /> Nova Categoria
                    </button>
                  </div>
                </div>

                <div className="card-body">
                  {data.length === 0 ? (
                    <>
                      {" "}
                      <div className="text-center">
                        {searchTerm && searchTerm.length > 0 ? (
                          <div className="d-flex flex-column align-items-center ">
                            <img src={vazio} style={{ width: "30%" }} />
                            <strong className="mt-3">
                              Nenhum produto cadastrado
                            </strong>
                          </div>
                        ) : (
                          <div className="d-flex flex-column align-items-center ">
                            <img src={vazio} style={{ width: "30%" }} />
                            <strong className="mt-3">
                              Nenhum produto cadastrado
                            </strong>
                          </div>
                        )}
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="mb-3"></div>
                      <table className="ntbl table table-sm table-bordered">
                        <thead>
                          <tr>
                            <th scope="col">ID do Atributo</th>
                            <th scope="col">Nome</th>
                            <th scope="col">Valor</th>
                            <th scope="col">Status</th>
                            <th>Criado Em</th>

                            <th>Opção</th>
                          </tr>
                        </thead>
                        <tbody>
                          {dataPaginada.map((item, index) => (
                            <>
                              <tr>
                                <td>{item.id}</td>
                                <td>{item.nome || "---"}</td>

                                <td>{item.valor || "---"}</td>
                                <td>{item.cns || "---"}</td>

                                <td>{item.created_at || "---"}</td>

                                <td>
                                  <button
                                    className="btn btn-primary"
                                    onClick={() => {
                                      this.setState({ edit: item });
                                    }}
                                  >
                                    <FontAwesomeIcon icon={faPen} />
                                  </button>
                                </td>
                              </tr>
                            </>
                          ))}
                        </tbody>
                      </table>
                      {data.length > 0 && (
                        <div className="d-flex justify-content-center">
                          <button
                            className="btn btn-secondary mx-1"
                            disabled={currentPage === 0}
                            onClick={() =>
                              this.handlePageChange(currentPage - 1)
                            }
                          >
                            <FontAwesomeIcon icon={faArrowLeft} /> Anterior
                          </button>

                          {[...Array(totalPages).keys()].map((page) => {
                            const isFirstPages = page < 3;
                            const isLastPages = page >= totalPages - 3;
                            const isAroundCurrent =
                              Math.abs(currentPage - page) <= 2;

                            if (
                              isFirstPages ||
                              isLastPages ||
                              isAroundCurrent
                            ) {
                              return (
                                <button
                                  key={page}
                                  className={`btn mx-1 ${
                                    currentPage === page
                                      ? "btn-primary"
                                      : "btn-outline-secondary"
                                  }`}
                                  onClick={() => this.handlePageChange(page)}
                                >
                                  {page + 1}
                                </button>
                              );
                            } else if (
                              (page === 3 && currentPage > 5) ||
                              (page === totalPages - 4 &&
                                currentPage < totalPages - 5)
                            ) {
                              return (
                                <span key={page} className="mx-2">
                                  ...
                                </span>
                              );
                            }

                            return null;
                          })}

                          <button
                            className="btn btn-secondary mx-1"
                            disabled={currentPage === totalPages - 1}
                            onClick={() =>
                              this.handlePageChange(currentPage + 1)
                            }
                          >
                            Próximo <FontAwesomeIcon icon={faArrowRight} />
                          </button>
                        </div>
                      )}
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <StaticDialog
          isOpen={this.state.new}
          title="Adicionar Atributo"
          onAfterClose={(result) => {
            this.setState({ new: false });
          }}
        >
          <div className="container">
            <TextField
              label={"Nome"}
              name={"nome"}
              onChange={this.handleChange}
              value={this.state.dados.nome || ""}
              variant="outlined"
              fullWidth
              margin="normal"
              InputProps={{
                style: {
                  height: 45,
                  padding: "0 5px",
                },
              }}
            />
            <TextField
              label="Valor"
              name="valor"
              value={
                this.state.dados.valor !== ""
                  ? this.state.dados.valor.toLocaleString("pt-BR", {
                      style: "currency",
                      currency: "BRL",
                    })
                  : ""
              }
              onChange={(e) => {
                const valorDigitado = e.target.value;

                // Remove tudo que não for número
                const somenteNumeros = valorDigitado.replace(/\D/g, "");

                // Se estiver vazio, zera
                const valor = somenteNumeros
                  ? Number(somenteNumeros) / 100
                  : "";

                // Atualiza o estado
                this.setState((prevState) => ({
                  dados: {
                    ...prevState.dados,
                    valor: valor,
                  },
                }));
              }}
              variant="outlined"
              fullWidth
              margin="normal"
              InputProps={{
                style: {
                  height: 45,
                  padding: "0 5px",
                },
              }}
            />
          </div>
          <div className="modal-footer">
            <button
              className="btn btn-primary"
              onClick={(e) => {
                var { nome, valor } = this.state.dados;

                e.target.classList.add("load");

                fetch(`${apiUrl}/cadastro/atributo`, {
                  method: "POST",
                  credentials: "include",
                  headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + Cookies.get("auth_token"),
                  },
                  body: JSON.stringify({ nome, valor }),
                }).then((response) => {
                  e.target.classList.remove("load");
                  if (response.status == 200) {
                    response.json().then((data) => {
                      toast.success("Atributo cadastrado com sucesso!");
                      this.setState((prevState) => ({
                        data: [...prevState.data, data],
                        new: false,
                        dados: { valor: 0 },
                      }));
                    });
                  }
                });
              }}
            >
              <FontAwesomeIcon icon={faSave} /> Salvar
            </button>
          </div>
        </StaticDialog>
      </main>
    );
  }
}

export default Atributos;
